import {GetStaticProps} from 'next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {useTranslation} from 'next-i18next';
import {FounderPage, JDG} from '../../components/home/founders';

export default function Jdg() {
    const {t} = useTranslation('jdg');

    return (
        <>
            <FounderPage
                title="JDG"
                subtitle="Fred & Seb du Grenier"
                bio={t('bio')}
                hide={'jdg'}
                founder={JDG}
                bgLargeSource="jdg_large.webp?v=4"
                bgLargeWidth={2558}
                bgLargeHeight={1064}
                bgMediumSource="jdg_medium.webp?v=4"
                bgMediumWidth={1453}
                bgMediumHeight={1064}
                colorFull="rgba(15,37,90,1)"
                colorEmpty="rgba(15,37,90,0)"
            />
        </>
    );
}

export const getStaticProps: GetStaticProps<{}> = async (context) => {
    const translation = await serverSideTranslations(context.locale, [
        'common',
        'founders',
        'jdg',
    ]);
    return {
        props: translation,
        revalidate: 86400, // 24 hours
    };
};
